export default __webpack_public_path__ + "static/media/manifiesto_portrait_en.f3330891.mp4";